import { QXMLObject } from "./QXMLObject";

export class QExcelRow extends QXMLObject {
  constructor() {
    super();
    this.fCellList = null;
  }

  Init() {
    this.fCellList = [];
  }

  AddCell(value) {
    this.fCellList.push(value);
  }
}
